import { Capacitor } from '@capacitor/core';

const NATIVE_VIEWPORT = 'width=device-width,initial-scale=1.0,minimum-scale=1.0,maximum-scale=1.0,user-scalable=no,viewport-fit=cover';

// I vincoli richiesti dalla WebView non devono modificare il gestionale web.
export function configureNativeShell({
  isNative = Capacitor.isNativePlatform(),
  documentRef = typeof document === 'undefined' ? null : document,
} = {}) {
  if (!isNative || !documentRef) return;

  documentRef.documentElement.classList.add('native-app');
  documentRef.querySelector('meta[name="viewport"]')?.setAttribute('content', NATIVE_VIEWPORT);

  const preventMultiTouchZoom = (event) => {
    if (event.touches?.length > 1) event.preventDefault();
  };
  const preventGestureZoom = (event) => event.preventDefault();

  documentRef.addEventListener('touchmove', preventMultiTouchZoom, { passive: false });
  documentRef.addEventListener('gesturestart', preventGestureZoom, { passive: false });
  documentRef.addEventListener('gesturechange', preventGestureZoom, { passive: false });
  documentRef.addEventListener('gestureend', preventGestureZoom, { passive: false });
}
